import * as Yup from 'yup';

const validationSchemaSaleLocation = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .max(45, 'Must be 45 characters or less'),
  email: Yup.string().nullable(),
  addressLineOne: Yup.string().nullable(),
  city: Yup.string().nullable(),
  phone: Yup.string().nullable(),
  addressLineTwo: Yup.string().nullable(),
  state: Yup.string().nullable(),
  zipCode: Yup.string().nullable(),
  notes: Yup.string().nullable()
});

export default validationSchemaSaleLocation;
